<script>
var $ = require('jQuery');
var MarkdownEditor = require('../../lib/markdown-editor.js');
var tectoastr = require('tectoastr');

export default {
  props: {
    initialMarkdown: {
      type: String,
      required: true
    },
    initialRaw: {
      type: String,
      required: true
    },
    order: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      editing: false,
      draft: this.initialRaw,
      editor: null,
      markdown: this.initialMarkdown.toString().clarify(),
      raw: this.initialRaw
    };
  },
  computed: {
    addActionVisible() {
      return !this.markdown && !this.editing;
    },

    notesVisible() {
      return this.markdown && !this.editing;
    }
  },
  mounted() {
    this.editor = new MarkdownEditor().singleEditor('#order-notes-editor');
  },
  updated() {
    this.editor.codemirror.refresh();
  },
  methods: {
    editNotes() {
      this.editing = true;
    },
    saveNotes() {
      this.draft = $('#order-notes-editor').val();
      $('#loader')
        .show()
        .fadeTo(250, 0.8);
      $.ajax({
        type: 'PUT',
        url: '/order/' + this.order + '/notes',
        dataType: 'json',
        data: {
          notes: this.draft
        },
        success: response => {
          this.editing = false;
          this.markdown = response.markdown;
          this.raw = this.draft;
        },
        error: error => {
          tectoastr.error(
            error.responseJSON.message ||
              $('#lang-strings #alerts-generic').text()
          );
        },
        complete: () => {
          $('#loader').fadeTo(250, 0, function() {
            $(this).hide();
          });
        }
      });
    },
    cancelNote() {
      this.editing = false;
      this.draft = $('#order-notes-editor').val();
    }
  }
};
</script>
